import { Icon } from '@iconify/react'
import { Button, Dropdown, Menu, MenuItem } from '@pepper/ui'

import { constructMenuList } from './QuickActions.utils'

import styles from './QuickActions.module.css'

type Props = {
  item: Item | Assignment
  hideWorkflow?: boolean
  onDelete?: () => void
  onRework?: () => void
  onApprove?: () => void
  onDownload?: () => void
  onWorkflowLogClick?: () => void
}

const QuickActions = ({
  item,
  hideWorkflow,
  onApprove,
  onDownload,
  onRework,
  onDelete,
  onWorkflowLogClick,
}: Props) => {
  const handleMenuClick = (key: string | number) => {
    switch (key) {
      case 'approve':
        onApprove?.()
        break
      case 'rework':
        onRework?.()
        break
      case 'download':
        onDownload?.()
        break
      case 'delete':
        onDelete?.()
        break
      case 'workflow_log':
        onWorkflowLogClick?.()
        break
      default:
        console.error(`${key} menu item not handled`)
    }
  }

  const menuList = constructMenuList({
    stage: item.stage,
    itemType: item.item_type,
    hideWorkflow: hideWorkflow ?? false,
  })
  const dropdownOverlay = (
    <Menu onClick={({ key }) => handleMenuClick(key)} className={styles.menu}>
      {menuList.map(menu => (
        <MenuItem key={menu.key} className={styles.menuItem}>
          <Icon icon={menu.icon} width="16" height="16" />
          <span>{menu.title}</span>
        </MenuItem>
      ))}
    </Menu>
  )

  return (
    <Dropdown
      overlay={dropdownOverlay}
      disabled={!menuList ? false : menuList.length === 0}
      trigger={['click']}
    >
      <Button
        icon={<Icon icon="fe:elipsis-v" width="18" height="18" />}
        size="small"
        type="text"
        title="More Options"
        aria-label="More Options"
      />
    </Dropdown>
  )
}

export default QuickActions
